module.exports = __webpack_public_path__ + "img/hover-xhs.c2ed7715.png";